import type { TinderCardItem } from '../types/look-config'

/**
 * Моки карточек для тестирования TinderLikeStep
 * Используются когда бекенд недоступен
 */
export const mockLookCards: TinderCardItem[] = [
  {
    id: '1',
    text: 'Деловой образ',
    subtitle: 'Элегантный костюм для офиса',
    image: 'https://images.unsplash.com/photo-1594938291221-94f18dd6d44b?w=800&h=1200&fit=crop'
  },
  {
    id: '2',
    text: 'Casual стиль',
    subtitle: 'Удобная повседневная одежда',
    image: 'https://images.unsplash.com/photo-1565084888279-aca607ecce0c?w=800&h=1200&fit=crop'
  },
  {
    id: '3',
    text: 'Вечерний наряд',
    subtitle: 'Элегантное платье для особых случаев',
    image: 'https://images.unsplash.com/photo-1566479179817-788839a30bfe?w=800&h=1200&fit=crop'
  },
  {
    id: '4',
    text: 'Спортивный образ',
    subtitle: 'Современная спортивная одежда',
    image: 'https://images.unsplash.com/photo-1544966503-7cc5ac882d5f?w=800&h=1200&fit=crop'
  },
  {
    id: '5',
    text: 'Уличная мода',
    subtitle: 'Смелый и яркий стиль',
    image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=800&h=1200&fit=crop'
  },
  {
    id: '6',
    text: 'Минималистичный стиль',
    subtitle: 'Простота и элегантность',
    image: 'https://images.unsplash.com/photo-1583292650898-7d22cd27ca6f?w=800&h=1200&fit=crop'
  },
  {
    id: '7',
    text: 'Романтический образ',
    subtitle: 'Нежные пастельные тона',
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=800&h=1200&fit=crop'
  },
  {
    id: '8',
    text: 'Роскошный гламур',
    subtitle: 'Блестящие акценты',
    image: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=800&h=1200&fit=crop'
  },
  {
    id: '9',
    text: 'Бохо стиль',
    subtitle: 'Свободные силуэты',
    image: 'https://images.unsplash.com/photo-1594633313593-bab3825d0caf?w=800&h=1200&fit=crop'
  },
  {
    id: '10',
    text: 'Винтажный шик',
    subtitle: 'Ретро элементы',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=1200&fit=crop'
  }
]

/**
 * Получить моковую карточку по индексу
 */
export function getMockLookCard(cardIndex: number): TinderCardItem {
  const index = cardIndex % mockLookCards.length
  return {
    ...mockLookCards[index],
    id: String(cardIndex + 1),
    text: `${mockLookCards[index].text} (${cardIndex + 1})`,
    subtitle: mockLookCards[index].subtitle
  }
}

